module.exports = __webpack_public_path__ + "img/img46.369d9d83.svg";